/**
 * @generated SignedSource<<570903e8c70b60b36dcc70da678d1d10>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AIAssetLibrarySortBy = "CREATED_DATE" | "NAME";
export type SortDirection = "ASC" | "DESC";
export type assetPickerDialogAssetsPaginationQuery$variables = {
  assetType?: string | null;
  categoryID?: number | null;
  count?: number | null;
  cursor?: string | null;
  sortBy?: AIAssetLibrarySortBy | null;
  sortDirection?: SortDirection | null;
};
export type assetPickerDialogAssetsPaginationQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"assetPickerDialogAssets_query">;
};
export type assetPickerDialogAssetsPaginationQuery = {
  response: assetPickerDialogAssetsPaginationQuery$data;
  variables: assetPickerDialogAssetsPaginationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "assetType"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "categoryID"
  },
  {
    "defaultValue": 50,
    "kind": "LocalArgument",
    "name": "count"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cursor"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "sortBy"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "sortDirection"
  }
],
v1 = {
  "kind": "Variable",
  "name": "assetType",
  "variableName": "assetType"
},
v2 = {
  "kind": "Variable",
  "name": "categoryID",
  "variableName": "categoryID"
},
v3 = {
  "kind": "Variable",
  "name": "sortBy",
  "variableName": "sortBy"
},
v4 = {
  "kind": "Variable",
  "name": "sortDirection",
  "variableName": "sortDirection"
},
v5 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "cursor"
  },
  (v1/*: any*/),
  (v2/*: any*/),
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  },
  (v3/*: any*/),
  (v4/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "assetPickerDialogAssetsPaginationQuery",
    "selections": [
      {
        "args": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "kind": "Variable",
            "name": "count",
            "variableName": "count"
          },
          {
            "kind": "Variable",
            "name": "cursor",
            "variableName": "cursor"
          },
          (v3/*: any*/),
          (v4/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "assetPickerDialogAssets_query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "assetPickerDialogAssetsPaginationQuery",
    "selections": [
      {
        "alias": null,
        "args": (v5/*: any*/),
        "concreteType": "AiAssetLibraryAssetsConnection",
        "kind": "LinkedField",
        "name": "aiAssetLibraryAssets",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AiAssetLibraryAssetsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AIAssetLibraryAssetDTO",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "fileUrl",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "thumbnailUrl",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "categoryName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v5/*: any*/),
        "filters": [
          "categoryID",
          "assetType",
          "sortBy",
          "sortDirection"
        ],
        "handle": "connection",
        "key": "assetPickerDialog_aiAssetLibraryAssets",
        "kind": "LinkedHandle",
        "name": "aiAssetLibraryAssets"
      }
    ]
  },
  "params": {
    "cacheID": "344ffe9bc0277048b666335d08a89439",
    "id": null,
    "metadata": {},
    "name": "assetPickerDialogAssetsPaginationQuery",
    "operationKind": "query",
    "text": "query assetPickerDialogAssetsPaginationQuery(\n  $assetType: String\n  $categoryID: Int\n  $count: Int = 50\n  $cursor: String\n  $sortBy: AIAssetLibrarySortBy\n  $sortDirection: SortDirection\n) {\n  ...assetPickerDialogAssets_query_42Qorf\n}\n\nfragment assetPickerDialogAssets_query_42Qorf on Query {\n  aiAssetLibraryAssets(first: $count, after: $cursor, categoryID: $categoryID, assetType: $assetType, sortBy: $sortBy, sortDirection: $sortDirection) {\n    edges {\n      node {\n        id\n        name\n        fileUrl\n        thumbnailUrl\n        categoryName\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "327224df4cc6458bb800e6fcb5feac08";

export default node;
